import React, { FC, useState } from 'react';
import { useSelector } from 'react-redux';

import { Drawer } from 'antd';

// Shared UI Library Components
import { CustomIcon, EIconName } from '@ppmcore/seven-ppm-core-shared-components-react';

// Styles
import './layout-header.scss';

// Components
import { LogoBlock } from '../../../../shared/components/logo-block/logo-block';
import { HeaderMenu } from '../header-menu/header-menu';
import { UserMenu } from '../user-menu/user-menu';

// Store entities
import { getCoreState } from '../../../../store/core/core.selectors';
import { getUserState } from '../../../../store/user/user.selectors';
import { getNotificationsState } from '../../../../store/notifications/notifications.selectors';

type TLayoutHeaderProps = {};

export const LayoutHeader: FC<TLayoutHeaderProps> = (
  {}: TLayoutHeaderProps
): JSX.Element => {

  const [menuListOpen, setMenuListOpen] = useState<boolean>(false);

  const { path } = useSelector(getCoreState);
  const { unread_count } = useSelector(getNotificationsState);
  const { user } = useSelector(getUserState);

  const toggleMenuList = (): void => {
    setMenuListOpen(!menuListOpen);
  }

  return (
    <div className="layout-header">
      <Drawer rootClassName="menu-list-drawer" title={ <LogoBlock/> }
              placement="left"
              onClose={ toggleMenuList } open={ menuListOpen }>
        <HeaderMenu unreadCount={ unread_count } withLabels={ true } pathState={ path } onItemClick={ toggleMenuList }/>
      </Drawer>

      <div className="layout-header--item">
        <CustomIcon name={ EIconName.Menu } onClick={ toggleMenuList }/>
      </div>
      <div className="layout-header--item item-logo">
        <LogoBlock/>
      </div>
      <div className="layout-header--item item-menu">
        <HeaderMenu unreadCount={ unread_count } pathState={ path }/>
      </div>
      <div className="layout-header--item">
        <UserMenu user={ user }/>
      </div>
    </div>
  )
};
